import React from 'react';
import { TestCollection } from '../../../../testcollection/TestCollection';
import { RelatedArticleType } from '../../../../../../../types/articleType';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface Props {
  value: { testscores: RelatedArticleType[] };
}
export const TestCollectionBlock = ({ value: { testscores } }: Props) => <TestCollection testCollection={testscores} />;

export const TestCollectionSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: Props) => (
      <ArticleBlockContentGridCol>
        <TestCollectionBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: Props) => <TestCollectionBlock value={value} />;
};
